export const TOUR_CONFIG = {
  MAX_RETRY_ATTEMPTS: 20,
  RETRY_DELAY_MS: 150,
  START_TOUR_RETRIES: 10,
  START_TOUR_DELAY: 200,
  MUTATION_DEBOUNCE_MS: 50,
} as const;
